"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _popUpHandler = _interopRequireDefault(require("../connectWindow/popUpHandler"));

var _MewConnectInitiator = _interopRequireDefault(require("../connectClient/MewConnectInitiator"));

var _web = _interopRequireDefault(require("web3"));

var _index = _interopRequireDefault(require("./web3Provider/web3-provider/index"));

var _index2 = _interopRequireDefault(require("./web3Provider/MEWconnect/index"));

var _index3 = _interopRequireDefault(require("./web3Provider/networks/index"));

var _url = _interopRequireDefault(require("url"));

var _events = _interopRequireDefault(require("events"));

var _events2 = _interopRequireDefault(require("./web3Provider/web3-provider/events"));

var _ethereumjsTx = require("ethereumjs-tx");

var _messages = require("../messages");

var _debug = _interopRequireDefault(require("debug"));

var _popUpCreator = _interopRequireDefault(require("../connectWindow/popUpCreator"));

var _platformDeepLinking = require("./platformDeepLinking");

var _config = require("../config");

var _package = _interopRequireDefault(require("../../package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const debugConnectionState = (0, _debug.default)('MEWconnect:connection-state');
const debugErrors = (0, _debug.default)('MEWconnectError');
let state = {
  wallet: null
};

const infuraUrlFormater = (name, infuraId) => {
  return "wss://".concat(name, ".infura.io/ws/v3/").concat(infuraId);
};

const eventHub = new _events.default();
let popUpCreator = {};
const recentDataRecord = [];

class Integration extends _events.default {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();

    if (window.web3) {
      if (window.web3.currentProvider) {
        if (window.web3.currentProvider.isMewConnect || window.web3.currentProvider.isTrust) {
          this.runningInApp = true;
          state.web3Provider = window.web3.currentProvider;
        } else {
          this.runningInApp = false;
        }
      } else {
        this.runningInApp = false;
      }
    } else {
      this.runningInApp = false;
    }

    this.windowClosedError = options.windowClosedError || false;
    this.subscriptionNotFoundNoThrow = options.subscriptionNotFoundNoThrow || true; // eslint-disable-next-line

    this.infuraId = !!options.infuraId ? options.infuraId : false;
    this.CHAIN_ID = options.chainId || 1;
    this.RPC_URL = options.rpcUrl || false;
    this.noUrlCheck = options.noUrlCheck || false;
    this.newNetworks = options.newNetworks || [];
    this.knownNetworks = new Set();
    this.lastHash = null;
    this.initiator = new _MewConnectInitiator.default();
    this.popUpHandler = new _popUpHandler.default();
    this.connectionState = false;
    this.chainIdMapping = this.createChainMapping(this.newNetworks);
    this.returnPromise = null;
    this.disconnectComplete = false;
    popUpCreator = new _popUpCreator.default();
  }

  closeDataChannelForDemo() {
    const connection = state.wallet.getConnection();
    connection.webRtcCommunication.closeDataChannelForDemo();
  }

  formatNewNetworks(newNetwork) {
    return {
      type: {
        name: newNetwork.name,
        name_long: newNetwork.name_long || newNetwork.name,
        homePage: newNetwork.homePage || '',
        blockExplorerTX: newNetwork.blockExplorerTX || '',
        blockExplorerAddr: newNetwork.blockExplorerAddr || '',
        chainID: newNetwork.chainId ? newNetwork.chainId : newNetwork.chainID ? newNetwork.chainID : this.CHAIN_ID,
        tokens: newNetwork.tokens || [],
        contracts: [],
        currencyName: newNetwork.currencyName || newNetwork.name
      },
      service: newNetwork.serviceName || newNetwork.name,
      url: newNetwork.url || this.RPC_URL,
      port: 443,
      auth: false,
      username: '',
      password: ''
    };
  }

  createChainMapping(newNetworks) {
    let networks = _index3.default;

    try {
      const additional = newNetworks.map(this.formatNewNetworks).reduce((acc, curr) => {
        acc[curr.type.name] = curr;
      }, {});
      networks = _objectSpread(_objectSpread({}, networks), additional);
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
    }

    return Object.keys(networks).reduce((acc, curr) => {
      if (networks[curr].length === 0) return acc;
      acc.push({
        name: networks[curr][0].type.name_long === 'Ethereum' ? 'mainnet' : networks[curr][0].type.name_long.toLowerCase(),
        chainId: networks[curr][0].type.chainID,
        key: networks[curr][0].type.name
      });
      this.knownNetworks.add(networks[curr][0].type.chainID);
      return acc;
    }, [{
      name: 'mainnet',
      chainId: 1,
      key: 'ETH'
    }]);
  }

  showNotifierDemo(details) {
    if (details === 'sent') {
      this.popUpHandler.showNotice({
        type: _messages.messageConstants.sent,
        hash: '0x543284135d7821e0271272df721101420003cb0e43e8c2e2eed1451cdb571fa4',
        explorerPath: state.network.type.blockExplorerTX
      });
    } else {
      this.popUpHandler.showNotice(details);
    }
  }

  showConnectedNotice() {
    this.popUpHandler.showConnectedNotice();
  }

  static get getConnectionState() {
    return _index2.default.getConnectionState();
  }

  static get isConnected() {
    return _index2.default.getConnectionState() !== _config.DISCONNECTED && _index2.default.getConnectionState() !== _config.CONNECTING;
  }

  get getWalletOnly() {
    if (state.wallet) {
      return state.wallet;
    }
  }

  enable() {
    popUpCreator.on('fatalError', () => {
      _index2.default.setConnectionState(_config.DISCONNECTED);
    });

    if (this.runningInApp) {
      return new Promise((resolve, reject) => {
        state.web3Provider.request({
          method: 'eth_requestAccounts',
          params: []
        }).then(address => {
          eventHub.emit('accountsChanged', address);
          this.popUpHandler.showConnectedNotice();

          _index2.default.setConnectionState(_config.CONNECTED);

          resolve(address);
        }).catch(console.error);
      });
    }

    return (0, _platformDeepLinking.nativeCheck)().then(res => {
      if (res) {
        if (typeof popUpCreator.popupWindowOpen === 'boolean') {
          popUpCreator.showDialog();
        }

        if (_index2.default.getConnectionState() === _config.DISCONNECTED) {
          this.returnPromise = this.enabler();
        }

        return this.returnPromise;
      }
    });
  }

  enabler() {
    // eslint-disable-next-line
    return new Promise(async (resolve, reject) => {
      if (!state.wallet && _index2.default.getConnectionState() === _config.DISCONNECTED) {
        _index2.default.setConnectionState(_config.CONNECTING);

        this.connectionState = _config.CONNECTING;
        debugConnectionState(_index2.default.getConnectionState());
        popUpCreator.setWindowClosedListener(() => {
          if (this.windowClosedError) {
            reject('ERROR: popup window closed');
          }

          this.emit('popupWindowClosed');
          popUpCreator.popupWindowOpen = null;
        });
        state.wallet = await (0, _index2.default)(state, popUpCreator, this.popUpHandler);
        console.log("Using MEWconnect v".concat(_package.default.version));
        this.popUpHandler.showConnectedNotice();
        this.popUpHandler.hideNotifier();
        this.createDisconnectNotifier();
        this.createCommunicationError();
        popUpCreator.popupWindowOpen = null;
        debugConnectionState(_index2.default.getConnectionState());
      }

      if (state.web3 && state.wallet) {
        await state.web3.eth.getTransactionCount(state.wallet.getChecksumAddressString());
      }

      if (state.web3Provider && state.wallet) {
        if (state.web3Provider.accountsChanged) {
          state.web3Provider.emit('accountsChanged', [state.wallet.getChecksumAddressString()]); // state.web3Provider.accountsChanged([
          //   state.wallet.getChecksumAddressString()
          // ]);
        }

        eventHub.emit('accounts_available', [state.wallet.getChecksumAddressString()]);
      }

      resolve([state.wallet.getChecksumAddressString()]);
    });
  }

  identifyChain(check) {
    if (typeof check === 'number') {
      const result = this.chainIdMapping.find(value => value.chainId === check);
      if (result) return result;
    } else if (typeof check === 'string') {
      let result = this.chainIdMapping.find(value => {
        return value.chainId.toString() == check.toLowerCase();
      });
      if (result) return result;
      result = this.chainIdMapping.find(value => value.name.toLowerCase() == check.toLowerCase());
      if (result) return result;
      result = this.chainIdMapping.find(value => value.key.toLowerCase() == check.toLowerCase());
      if (result) return result;
    }

    return 'ETH';
  }

  makeWeb3Provider() {
    let CHAIN_ID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.CHAIN_ID;
    let RPC_URL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.RPC_URL;

    let _noCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.noUrlCheck;

    let chainError = false;
    let web3Provider;

    try {
      if (this.runningInApp) {
        if (state.web3Provider) {
          web3Provider = state.web3Provider;
        } else {
          web3Provider = window.web3.currentProvider;
        }
      } else {
        let chain, defaultNetwork;

        if (this.knownNetworks.has(CHAIN_ID)) {
          chain = this.identifyChain(CHAIN_ID || 1);
          defaultNetwork = _index3.default[chain.key][0];
          state.network = defaultNetwork;
        } else {
          chain = {
            name: 'unknown'
          };
          defaultNetwork = this.formatNewNetworks({
            name: 'unknown'
          });
          state.network = defaultNetwork;
        }

        if (this.infuraId && !this.RPC_URL) {
          RPC_URL = infuraUrlFormater(chain.name, this.infuraId);
        }

        const hostUrl = _url.default.parse(RPC_URL || defaultNetwork.url);

        const options = {
          subscriptionNotFoundNoThrow: this.subscriptionNotFoundNoThrow
        };

        if (!/[wW]/.test(hostUrl.protocol) && !/[htpHTP]/.test(hostUrl.protocol)) {
          throw Error('Invalid rpc endpoint supplied to MEWconnect during setup');
        }

        if (!_noCheck && !this.infuraId) {
          if (!hostUrl.hostname.includes(chain.name) && hostUrl.hostname.includes('infura.io')) {
            chainError = true;
            throw Error("ChainId: ".concat(CHAIN_ID, " and infura endpoint ").concat(hostUrl.hostname, " don't match"));
          }
        }

        const parsedUrl = "".concat(hostUrl.protocol, "//").concat(hostUrl.hostname ? hostUrl.hostname : hostUrl.host).concat(hostUrl.port ? ':' + hostUrl.port : '').concat(hostUrl.pathname ? hostUrl.pathname : '');
        state.enable = this.enable.bind(this);
        web3Provider = new _index.default(parsedUrl, options, {
          state: state
        }, eventHub);
      }

      state.enable = this.enable.bind(this);
      web3Provider.close = this.disconnect; //.bind(this);

      web3Provider.disconnect = this.disconnect.bind(this);
      state.web3Provider = web3Provider;
      state.web3 = new _web.default(web3Provider);

      if (!this.runningInApp) {
        state.web3.currentProvider.sendAsync = state.web3.currentProvider.send;
      }

      this.setupListeners();
      web3Provider.enable = this.enable.bind(this);
      web3Provider.isMewConnect = true;
      web3Provider.isMEWconnect = true;
      web3Provider.name = 'MewConnect';
      return web3Provider;
    } catch (e) {
      debugErrors('makeWeb3Provider ERROR');

      if (chainError) {
        throw e;
      } else {
        // eslint-disable-next-line
        console.error(e);
      }
    }
  }

  createDisconnectNotifier() {
    const connection = state.wallet.getConnection();
    debugConnectionState(_index2.default.getConnectionState());
    connection.webRtcCommunication.on(connection.lifeCycle.RtcDisconnectEvent, () => {
      try {
        if (this.popupCreator) this.popUpHandler.showNotice(_messages.messageConstants.disconnect);

        _index2.default.setConnectionState(connection.lifeCycle.disconnected);

        if (state.wallet !== null) {
          this.emit('close');
          this.emit('disconnect');
        }

        if (state.wallet !== null && state.web3Provider) {
          state.web3Provider.emit('disconnect');
          state.web3Provider.emit('close');
        }

        if (state.wallet !== null && state.web3Provider.disconnectCallback) {
          state.web3Provider.disconnectCallback();
        }

        if (state.wallet !== null && state.web3Provider.closeCallback) {
          state.web3Provider.closeCallback();
        }

        state.wallet = null;
        this.emit(_config.DISCONNECTED);
        this.emit('close');
        this.emit('disconnect');
      } catch (e) {
        if (this.popUpHandler) {
          this.popUpHandler.showNotice(_messages.messageConstants.disconnectError);
        }
      }
    });
    connection.webRtcCommunication.on(connection.lifeCycle.RtcClosedEvent, () => {
      try {
        this.popUpHandler.showNotice(_messages.messageConstants.disconnect);

        _index2.default.setConnectionState(connection.lifeCycle.disconnected);

        if (state.wallet !== null) {
          this.emit('close');
          this.emit('disconnect');
        }

        if (state.wallet !== null && state.web3Provider) {
          state.web3Provider.emit('disconnect');
          state.web3Provider.emit('close');
        }

        if (state.wallet !== null && state.web3Provider.disconnectCallback) {
          state.web3Provider.disconnectCallback();
        }

        if (state.wallet !== null && state.web3Provider.closeCallback) {
          state.web3Provider.closeCallback();
        }

        state.wallet = null;
        this.emit(connection.lifeCycle.disconnected);
      } catch (e) {
        if (this.popUpHandler) {
          this.popUpHandler.showNotice(_messages.messageConstants.disconnectError);
        }
      }
    });
  }

  createCommunicationError() {
    const connection = state.wallet.getConnection();
    connection.webRtcCommunication.on(connection.lifeCycle.decryptError, () => {
      if (this.popupCreator) this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.communicationError);
    });
  }

  disconnect() {
    try {
      if (this.runningInApp) {
        return true;
      }

      if (state.wallet) {
        const connection = state.wallet.getConnection();
        connection.disconnectRTC();

        _index2.default.setConnectionState(_config.DISCONNECTED);

        return true;
      }

      state = {}; // eslint-disable-next-line

      console.warn('No connected wallet found');
      return true;
    } catch (e) {
      debugErrors('disconnect ERROR');

      if (this.popUpHandler) {
        this.popUpHandler.showNotice(_messages.messageConstants.disconnectError);
      } // eslint-disable-next-line


      console.error(e);
      return false;
    }
  }

  sign(tx) {
    if (state.wallet) {
      return state.wallet.signTransaction(tx);
    }
  }

  setupListeners() {
    const transactionCache = [];
    eventHub.on(_events2.default.SHOW_TX_CONFIRM_MODAL, (tx, resolve) => {
      this.responseFunction = resolve;

      if (!state.wallet) {
        this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.notConnected);
      } else {
        this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.approveTx);
        state.wallet.signTransaction(tx).then(_response => {
          if (!transactionCache.includes(_response.tx.hash)) {
            transactionCache.push(_response.tx.hash);
            this.popUpHandler.showNoticePersistentExit();
            resolve(_response);
          }
        }).catch(err => {
          this.popUpHandler.showNoticePersistentExit();

          if (err.reject) {
            this.popUpHandler.noShow();
            setTimeout(() => {
              this.popUpHandler.showNotice('decline');
            }, 250);
          } else {
            debugErrors('sign transaction ERROR');
            state.wallet.errorHandler(err);
          }

          resolve(err);
        });
      }
    });
    eventHub.on(_events2.default.WALLET_NOT_CONNECTED, () => {
      if (!state.wallet) {
        this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.notConnected);
      }
    });
    eventHub.on(_events2.default.ERROR_NOTIFY, err => {
      if (err && err.message) {
        this.popUpHandler.showNotice(err.message);
      }
    });
    eventHub.on(_events2.default.SHOW_MSG_CONFIRM_MODAL, (msg, resolve) => {
      if (!state.wallet) {
        this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.notConnected);
      } else {
        this.popUpHandler.showNoticePersistentEnter(_messages.messageConstants.signMessage);
        state.wallet.signMessage(msg).then(result => {
          resolve(result);
        }).catch(err => {
          if (err.reject) {
            this.popUpHandler.noShow();
            setTimeout(() => {
              this.popUpHandler.showNotice(_messages.messageConstants.declineMessage);
            }, 250);
          } else {
            debugErrors('sign message ERROR');
            state.wallet.errorHandler(err);
          }

          resolve(err);
        });
      }
    }); // TODO: Is this getting used???

    eventHub.on('showSendSignedTx', (tx, resolve) => {
      this.popUpHandler.showNotice(_messages.messageConstants.approveTx);
      const newTx = new _ethereumjsTx.Transaction(tx);
      this.responseFunction = resolve;
      this.signedTxObject = {
        rawTransaction: tx,
        tx: {
          to: "0x".concat(newTx.to.toString('hex')),
          from: "0x".concat(newTx.from.toString('hex')),
          value: "0x".concat(newTx.value.toString('hex')),
          gasPrice: "0x".concat(newTx.gasPrice.toString('hex')),
          gas: "0x".concat(newTx.gas.toString('hex')),
          gasLimit: "0x".concat(newTx.gasLimit.toString('hex')),
          data: "0x".concat(newTx.data.toString('hex')),
          nonce: "0x".concat(newTx.nonce.toString('hex')),
          v: "0x".concat(newTx.v.toString('hex')),
          r: "0x".concat(newTx.r.toString('hex')),
          s: "0x".concat(newTx.s.toString('hex'))
        }
      };
      this.responseFunction(this.signedTxObject);
    });
    eventHub.on('Hash', hash => {
      this.lastHash = hash;
      this.popUpHandler.showNotice({
        type: _messages.messageConstants.sent,
        hash: hash,
        explorerPath: state.network.type.blockExplorerTX
      }, 10000);
    });
    eventHub.on('Receipt', () => {
      this.lastHash = null;
      this.popUpHandler.showNotice(_messages.messageConstants.complete);
    });
    eventHub.on('Error', e => {
      debugErrors('SendTx:Error ERROR');

      if (this.lastHash !== null) {
        this.popUpHandler.showNotice({
          type: _messages.messageConstants.failed,
          hash: this.lastHash,
          explorerPath: state.network.type.blockExplorerTX
        }, 10000);
      } else {
        this.popUpHandler.showNotice(_messages.messageConstants.error);
      }
    });
  }

}

exports.default = Integration;